import React, { useEffect, useState, useCallback, useRef } from 'react';
import useApp from 'hooks/useApp'
import { Layer } from 'components'
import styles from '../index.module.css'
import Lib from 'library'
import { financeCardDetailLayerController } from './states'
import { useRecoilState, useRecoilValue } from 'recoil';

const FinanceCardDetailLayer = () => {

	const [layerControl, setLayerControl] = useRecoilState(financeCardDetailLayerController)

	return (
		<Layer show={layerControl.show} closeLayer={() => setLayerControl(prev => ({ ...prev, show: false }))}>
			<LayerContent />
		</Layer>
	)
}

const LayerContent = () => {

	const App = useApp()
	const [tabList, setTabList] = useState(0)
	const [cardData, setCardData] = useState(null);
	const [mainBenefit, setMainBenefit] = useState([]);
	const [normalBenefit, setNormalBenefit] = useState([]);
	const [benefitCode, setBenefitCode] = useState([]);
	const mounted = useRef(false);
	const img = useRef(null);

	const layerControl = useRecoilValue(financeCardDetailLayerController)

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: undefined,
			right: undefined
		})
		// App.setShowNav(false) // 무의미함. Layer.jsx 동작하면서 hide 되는 것 같음.
		// document.querySelector("nav .active") 그대로 남아 있음.
		document.querySelector("nav .active")?.classList.remove("active"); // 강제로 제거.

		return App.setShowNav(true)
	}, [])


	const onFold = e => {
		const target = e.currentTarget || e.target
		const menu = target.querySelector(".menu-open")
		if (target.classList.contains("active")) {
			target.classList.remove("active")
			menu.style.height = 0
		} else {
			target.parentElement.childNodes.forEach(item => {
				item.classList.remove("active")
			})
			document.querySelectorAll(".menu-open").forEach(item => {
				item.style.height = 0
			})
			const p = menu.querySelector("p")
			const style = window.getComputedStyle(p)
			let height = 0
			height += Number(style.height.replace("px", ""))
			height += Number(style.marginTop.replace("px", ""))
			height += Number(style.marginBottom.replace("px", ""))
			menu.style.height = `${height}px`
			target.classList.add("active")
		}
	}

	const getCardDetail = useCallback((cardId) => {
		// 카드상세 받아오기
		Lib.myGet(`/api/recomm/card/v1/${cardId}`, data => {
		// Lib.post(`/api/finance/cardbnftLst?cardId=${cardId}`, data => {	
			const detailData = data.data;
			// 카드 데이터
			console.log(detailData)
			setCardData(detailData);
			// 혜택 데이터, 공통 코드 함께 전달
			Lib.myGet('/api/auth/sncnApis/v1', data => keyBnftsLst(detailData.cardBenefits, data.filter((item) => item.api_nm == '금융상품추천')[0]));


			
			// 기존코드 원본
			// const _data = data.find(card => card.cardId === cardId);
			// const { keyBnftsCd1, keyBnftsCd2, keyBnftsCd3, keyBnftsCd4, keyBnftsCd5, admnscsSmry, admnscsDet, alwtsSmry, alwtsDet, shpngSmry, shpngDet, olngSmry, olngDet, sprmrSmry, sprmrDet, fnncSmry, fnncDet, airmlgDet, airmlgSmry, anfespSmry, anfespDet, autoSmry, autoDet, bchrSmry, bchrDet, btySmry, btyDet, cafeSmry, cafeDet, chkcrdSmry, chkcrdDet, chldcrSmry, chldcrDet, clturSmry, clturDet, cvnstrSmry, cvnstrDet, dnngSmry, dnngDet, easypySmry, easypyDet, edcSmry, edcDet, grncrdSmry, grncrdDet, hipsSmry, hipsDet, lgflrfSmry, lgflrfDet, lsrSmry, lsrDet, mdclSmry, mdclDet, movieSmry, movieDet, ntnlhpSmry, ntnlhpDet, pbltrnspSmry, pbltrnspDet, pntcsSmry, pntcsDet, prmmSmry, prmmDet, rntlSmry, rntlDet, prtpsSmry, prtpsDet, telcomSmry, telcomDet, thcjSmry, thcjDet } = _data;

			// const _lst = [
			// 	{ code: "OPT100", name: "언제나할인", smry: alwtsSmry, det: alwtsDet },
			// 	{ code: "OPT301", name: "쇼핑", smry: shpngSmry, det: shpngDet },
			// 	{ code: "OPT201", name: "주유", smry: olngSmry, det: olngDet },
			// 	{ code: "OPT302", name: "대형마트", smry: sprmrSmry, det: sprmrDet },
			// 	{ code: "OPT309", name: "금융", smry: fnncSmry, det: fnncDet },
			// 	{ code: "OPT601", name: "항공마일리지", smry: airmlgDet, det: airmlgSmry },
			// 	{ code: "OPT103", name: "연회비지원", smry: anfespSmry, det: anfespDet },
			// 	{ code: "OPT310", name: "관리비", smry: admnscsSmry, det: admnscsDet },
			// 	{ code: "OPT205", name: "오토", smry: autoSmry, det: autoDet },
			// 	{ code: "OPT104", name: "바우처", smry: bchrSmry, det: bchrDet },
			// 	{ code: "OPT307", name: "뷰티", smry: btySmry, det: btyDet },
			// 	{ code: "OPT305", name: "카페/베이커리", smry: cafeSmry, det: cafeDet },
			// 	{ code: "OPT312", name: "체크카드겸용", smry: chkcrdSmry, det: chkcrdDet },
			// 	{ code: "OPT502", name: "육아", smry: chldcrSmry, det: chldcrDet },
			// 	{ code: "OPT402", name: "문화", smry: clturSmry, det: clturDet },
			// 	{ code: "OPT303", name: "편의점", smry: cvnstrSmry, det: cvnstrDet },
			// 	{ code: "OPT304", name: "외식", smry: dnngSmry, det: dnngDet },
			// 	{ code: "OPT101", name: "간편결제", smry: easypySmry, det: easypyDet },
			// 	{ code: "OPT501", name: "교육", smry: edcSmry, det: edcDet },
			// 	{ code: "OPT105", name: "그린카드", smry: grncrdSmry, det: grncrdDet },
			// 	{ code: "OPT204", name: "하이패스", smry: hipsSmry, det: hipsDet },
			// 	{ code: "OPT203", name: "경차유류환급", smry: lgflrfSmry, det: lgflrfDet },
			// 	{ code: "OPT403", name: "레저", smry: lsrSmry, det: lsrDet },
			// 	{ code: "OPT306", name: "의료", smry: mdclSmry, det: mdclDet },
			// 	{ code: "OPT401", name: "영화", smry: movieSmry, det: movieDet },
			// 	{ code: "OPT503", name: "국민행복카드", smry: ntnlhpSmry, det: ntnlhpDet },
			// 	{ code: "OPT202", name: "대중교통", smry: pbltrnspSmry, det: pbltrnspDet },
			// 	{ code: "OPT102", name: "포인트/캐시백", smry: pntcsSmry, det: pntcsDet },
			// 	{ code: "OPT603", name: "프리미엄", smry: prmmSmry, det: prmmDet },
			// 	{ code: "OPT308", name: "렌탈", smry: rntlSmry, det: rntlDet },
			// 	{ code: "OPT602", name: "Priority Pass", smry: prtpsSmry, det: prtpsDet },
			// 	{ code: "OPT311", name: "통신", smry: telcomSmry, det: telcomDet },
			// 	{ code: "OPT106", name: "THE CJ카드", smry: thcjSmry, det: thcjDet },
			// ]
			// keyBnftsLst(_lst, keyBnftsCd1, keyBnftsCd2, keyBnftsCd3, keyBnftsCd4, keyBnftsCd5);
			// setCardData(_data)
		});
	}, []);

	const keyBnftsLst = (bnftList, coCodeList) => {
		// console.log('coCodeList', coCodeList.api_codes)
		const codeList = coCodeList.api_codes;
		let mainResult = []
		let normarResult = []

		for(var i=0; i < bnftList.length; i++) {
			const { category, smry, dsctn } = bnftList[i];
			// 혜택 넘버로 넣을려니 공백오류 생겨서 맞게 조정함
			let priorityNum = bnftList[i].priority -1
			if (priorityNum < 5) {
				if(!mainResult[priorityNum]){
					mainResult[priorityNum] = {
						priority: bnftList[i].priority,
						// 카테고리 기준 타이틀 한글명으로 변경
						name: codeList.filter((code) => code.cd_id == category)[0].cd_nm,
						list: []
					};
				}
				mainResult[priorityNum].list.push({
					smry: smry,
					// 줄바꿈으로 join처리
					dsctn: dsctn.join('\n'),
				});
			}else{
				// 혜택 6이상의 리스트로 -5 처리함
				if(!normarResult[priorityNum - 5]){
					normarResult[priorityNum - 5] = {
						priority: bnftList[i].priority,
						name: codeList.filter((code) => code.cd_id == category)[0].cd_nm,
						list: []
					};
				}
				normarResult[priorityNum - 5].list.push({
					smry: smry,
					dsctn: dsctn.join('\n'),
				});
			}
			  
		}
		setMainBenefit(mainResult);
		setNormalBenefit(normarResult);
		
		// 원본코드
		// let lst = [];
		// let bnftFilterLst = []

		// bnfts.forEach(bnft => {
		// 	if (bnft === undefined) return true;
		// 	const result = bnftList.find(item => bnft === item.code);
		// 	bnftFilterLst = bnftList.filter(item => item.smry !== "");
		// 	lst = [...lst, result];
		// });

		// const bnftLstFilter = bnftFilterLst.filter(item => item.smry !== "" && item.code !== bnfts[0] && item.code !== bnfts[1] && item.code !== bnfts[2] && item.code !== bnfts[3] && item.code !== bnfts[4]);

		// setNormalBenefit(bnftLstFilter);
		// setMainBenefit(lst);
	};
	useEffect(() => {
		if (layerControl.show) {
			mounted.current = true;
			setCardData()
			mounted.current && getCardDetail(layerControl.cardId)
		} else {
			mounted.current = false;
		}
	}, [layerControl.show])

	const foldStyle = {
		transition: "height 0.4s",
		height: 0,
		overflow: "hidden"
	}

	return (
		<div className="page">
			{
				cardData ?
					<>
						<div className="flex_1">
							<div className="shadow">
								<div className="padding">
									<div className={styles["card-info"]}>
										<div>
											<p>{cardData.cardCoNm}  {cardData.isMycard && <i className="tag tag-round tag-blue ml_5">MY</i>}</p>
											<strong className="mt_5">{cardData.cardNm}</strong>
										</div>
										<span>Since. {cardData.releaseDate}</span>
									</div>
									<div className={`${styles["card-img"]} mt_30`}>
										<div className="img-box cmm-card" style={{ marginTop: "2rem", marginBottom: "2.5rem", height: "16rem" }}>
											<img ref={img} src={cardData.cardImgUrl} alt="" />
										</div>
										{cardData.dsctnSmry.map((dsctn, index) => 
											<div key={index} className="text-blue text-align_center" style={{ whiteSpace: 'pre-wrap' }}>
												{dsctn}
											</div>
										)}
									</div>
									<hr className="my_40" />
									<ul className="list-item list-item-left" style={{ fontSize: "1.2rem" }}>
										<li>
											<span><i className="icon icon_title_won mr_5" />연회비</span>
											<span>
												<em>국내 {cardData.domesticAnnualFee == '0' || cardData.domesticAnnualFee == 'null' ? '없음': Lib.numberToKorean(Number(cardData.domesticAnnualFee)) + '원'}, </em>
												<em>해외 {cardData.foreignAnnualFee == '0' || cardData.foreignAnnualFee == 'null'? '없음': Lib.numberToKorean(Number(cardData.foreignAnnualFee)) + '원'}, </em>
												<em>가족겸용 {cardData.familyAnnualFee == '0' || cardData.familyAnnualFee == 'null' ? '없음' : Lib.numberToKorean(Number(cardData.familyAnnualFee)) +'원'}</em>
											</span>
										</li>
										<li>
											<span><i className="icon icon_title_graph mr_5" />기준실적</span>
											
											{cardData.hasBsrcd ? 
												<span>
													{cardData.bsrcdUnit == 'year'
														?<>
															<em>{cardData.bsrcdTerm == 'before' ? '전년도 ' : '당해 연도 '}</em>
															{cardData.bsrcdVal !== 'null' && <em>{cardData.bsrcdVal}</em>}
															<em>년 </em>
														</>
														:<>
															<em>{cardData.bsrcdTerm == 'before' ? '전월 ' : '당월 '}</em>
															{cardData.bsrcdVal !== 'null' && <em>{cardData.bsrcdVal}개월</em>}
														</>
													}
													<em>{cardData.bsrcdMethod =='sum' ? ' 합계 ' : ' 평균 '}</em>
													<em>{Lib.numberToKorean(Number(cardData.bsrcdMinVal))  + '원 이상'}</em>
												</span>
											: <span>조건없음</span>
											}
										</li>
									</ul>
								</div>
							</div>
							<div className="padding">
								<ul className="tab-round">
									<li onClick={() => setTabList(0)} className={tabList === 0 ? "active" : ""}>주요혜택</li>
									{normalBenefit.length > 0 && <li onClick={() => setTabList(1)} className={tabList === 1 ? "active" : ""}>일반혜택</li>}
									{cardData.benefitNotices.length > 0 && <li onClick={() => setTabList(2)} className={tabList === 2 ? "active" : ""}>부가혜택</li>}
									<li onClick={() => setTabList(3)} className={tabList === 3 ? "active" : ""}>유의사항</li>
								</ul>
								{/* 주요혜택 탭 */}
								{tabList === 0 &&
									<ul className={`${styles["card-benefit"]} accordion-list mt_20`}>
										{mainBenefit && mainBenefit.map((bnft, index) =>
											<li key={bnft.priority} onClick={onFold}>
												<div className="flex-justify_between align_center">
													<div className={styles.title}>
														<p>{bnft.name}</p>
														<span className="mt_5">{bnft.list[0].smry}</span>
													</div>
													<i className="icon icon_arrow_sm bottom" />
												</div>
												<div className="menu-open block" style={foldStyle}>
													<p className={styles["card-benefit-txt"]}>
													{bnft.list.map((list, index) =>
														<span key={index} className='mt_20'><b>{list.smry}</b><br/>{list.dsctn}</span>
															)}
														</p>
												</div>
											</li>
										)}
									</ul>
								}

								{tabList === 1 &&
									<ul className={`${styles["card-benefit"]} accordion-list mt_20`}>
										{normalBenefit && normalBenefit.map((bnft, index) =>
											<li key={bnft.priority} onClick={onFold}>
												<div className="flex-justify_between align_center">
													<div className={styles.title}>
														<p>{bnft.name}</p>
														<span className="mt_5">{bnft.list[0].smry}</span>
													</div>
													<i className="icon icon_arrow_sm bottom" />
												</div>
												<div className="menu-open block" style={foldStyle}>
													<p className={styles["card-benefit-txt"]}>
													{bnft.list.map((list, index) =>
														<span key={index} className='mt_20'><b>{list.smry}</b><br/>{list.dsctn}</span>
															)}
														</p>
												</div>
											</li>
										)}
									</ul>
								}

								{tabList === 2 &&
									<div className="mt_30">
										{cardData.benefitNotices.map((notices, index) => 
											<div key={index} style={{ fontSize: "1.2rem", color: "#666", whiteSpace: "pre-wrap" }} className="mt_10">
												{notices}
											</div>
										)}
									</div>
								}

								{tabList === 3 &&
									<div className="mt_30">
										{cardData.extraDesc.map((desc, index) => 
											<div key={index} style={{ fontSize: "1.2rem", color: "#666", whiteSpace: "pre-wrap" }} className="mt_10">
												{desc}
											</div>
										)}
									</div>
								}
							</div>
						</div>
						{/* <div className="flex-shrink_0 padding">
							<Button className="btn btn--big">카드 신청하기</Button>
						</div> */}
					</>
					:
					<div className="flex_1">
						<div className="shadow gray">
							<div className="padding">
								<div className={styles["card-info"]}>
									<div>
										<p><i className="skeleton" style={{ width: "5rem" }}></i></p>
										<strong className="mt_5 skeleton" style={{ width: "7rem" }}></strong>
									</div>
									<span><span className="skeleton" style={{ width: "4rem" }} /><span className="skeleton ml_5" style={{ width: "5rem" }} /></span>
								</div>
								<div className={`${styles["card-img"]} mt_30`}>
									<div className="img-box" style={{ marginTop: "2rem", marginBottom: "2.5rem", width: "16rem", height: "10.2rem" }}>
										<div className="skeleton" style={{ width: "16rem", height: "10rem" }} />
									</div>
									<div className="text-blue text-align_center" style={{ whiteSpace: 'pre-wrap' }}>
										<span className="skeleton" style={{ width: "8rem" }}></span>
									</div>
								</div>
								<hr className="my_40" />
								<ul>
									<li>
										<span style={{ width: "auto" }}><i className="skeleton mr_5" style={{ width: "1.2rem", height: "1.2rem", minHeight: "1.2rem" }} /> <span className="skeleton ml_5" style={{ width: "4rem" }} /><span className="skeleton ml_5" style={{ width: "6rem" }} /></span>
									</li>
									<li className="mt_10">
										<span style={{ width: "auto" }}><i className="skeleton mr_5" style={{ width: "1.2rem", height: "1.2rem", minHeight: "1.2rem" }} /> <span className="skeleton ml_5" style={{ width: "5rem" }} /><span className="skeleton ml_5" style={{ width: "8rem" }} /></span>
									</li>
								</ul>
							</div>
						</div>
						<div className="padding">
							<ul className="flex-align_center">
								<li className="skeleton" style={{ width: "7rem", height: "2.5rem" }} />
								<li className="skeleton ml_10" style={{ width: "7rem", height: "2.5rem" }} />
								<li className="skeleton ml_10" style={{ width: "7rem", height: "2.5rem" }} />
							</ul>
							<ul className={`${styles["card-benefit"]} accordion-list`}>
								{
									[...new Array(3)].map((item, index) => {
										return (
											<li key={index} style={{ borderBottomColor: "#eee" }}>
												<div className="flex-justify_between align_center">
													<div className={styles.title}>
														<p className="skeleton" style={{ width: "7rem" }}></p>
														<span className="mt_5 skeleton" style={{ width: "5rem" }} />
													</div>
													<i className="skeleton" style={{ width: "2rem" }} />
												</div>
												<div className="menu-open block" style={foldStyle}>
													<p className={styles["card-benefit-txt"]}>det</p>
												</div>
											</li>
										)
									})
								}
							</ul>
						</div>
					</div>
			}
		</div>
	)
}

export default FinanceCardDetailLayer